import { useMemo } from 'react';
import { useApiWithRetry } from '../hooks/useApiWithRetry';
import { TenantsApiResponse, Tenant } from '../types/tenant';

/**
 * Serviço para gerenciar operações relacionadas aos tenants
 */
export class TenantsService {
  private api: ReturnType<typeof useApiWithRetry>;

  constructor(api: ReturnType<typeof useApiWithRetry>) {
    this.api = api;
  }

  /**
   * Busca todos os tenants acessíveis para o usuário atual
   */
  async getTenants(): Promise<Tenant[]> {
    try {
      const response: TenantsApiResponse = await this.api.get<TenantsApiResponse>('/tenants/');
      
      // Adicionar cores padrão para os tenants que não possuem
      const tenantsWithColors = response.tenants.map((tenant, index) => ({
        ...tenant,
        color: tenant.color || this.getDefaultColor(index)
      }));

      return tenantsWithColors;
    } catch (error) {
      console.error('Erro ao buscar tenants:', error);
      throw error;
    }
  }

  /**
   * Gera uma cor padrão baseada no índice do tenant
   */
  private getDefaultColor(index: number): string {
    const colors = [
      '#2196F3', // Azul
      '#FF5722', // Vermelho
      '#4CAF50', // Verde
      '#FF9800', // Laranja
      '#9C27B0', // Roxo
      '#607D8B', // Azul acinzentado
      '#E91E63', // Rosa
      '#795548', // Marrom
      '#009688', // Teal
      '#3F51B5', // Índigo
    ];
    
    return colors[index % colors.length];
  }
}

/**
 * Hook para usar o serviço de tenants
 */
export const useTenantsService = () => {
  const api = useApiWithRetry();
  return useMemo(() => new TenantsService(api), []);
};
